import { render } from "./index.vue?vue&type=template&id=d22b567e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d22b567e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22b567e"]])

export default __exports__